import React from 'react';
import { Box, Typography } from '@mui/material';

const FallbackLogo = ({ size = 40, color = 'white', showText = true }) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: size * 0.25,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
      }}
    >
      {/* Simple business card icon */}
      <Box
        sx={{
          width: size * 0.6,
          height: size * 0.35,
          backgroundColor: color,
          borderRadius: size * 0.04,
          opacity: 0.9,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          px: size * 0.05,
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '20%',
            left: '10%',
            width: '40%',
            height: '8%',
            backgroundColor: '#667eea',
            borderRadius: size * 0.01,
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '35%',
            left: '10%',
            width: '60%',
            height: '6%',
            backgroundColor: '#667eea',
            borderRadius: size * 0.01,
            opacity: 0.7,
          },
        }}
      >
        {/* Person icon in card */}
        <Box
          sx={{
            position: 'absolute',
            right: '15%',
            top: '15%',
            width: size * 0.08,
            height: size * 0.08,
            borderRadius: '50%',
            backgroundColor: '#4facfe',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            right: '12%',
            bottom: '20%',
            width: size * 0.14,
            height: size * 0.08,
            backgroundColor: '#4facfe',
            borderRadius: size * 0.02,
          }}
        />
      </Box>
      
      {/* Optional text */}
      {showText && size >= 32 && (
        <Typography
          sx={{
            fontSize: size * 0.12,
            fontWeight: 600,
            color: color,
            mt: size * 0.02,
            opacity: 0.9,
          }}
        >
          MSB
        </Typography>
      )}
    </Box>
  );
};

export default FallbackLogo;